import styled from 'styled-components';

export const StyledResearchPage = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 320px;
`;